import type { CSSProperties } from 'react';

/**
 * Shared inline-style tokens for the Organizations onboarding hero. Built only
 * from `--vn-*` design tokens — no hardcoded colors. Hover/gradient/halo
 * affordances live in `onboarding-css.tsx` (class-based). Mirrors the SSL
 * inventory + Healthcheck + OSS onboarding visual language.
 */

export const heroWrap: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  gap: 'var(--vn-space-3)',
  padding: 'var(--vn-space-10) var(--vn-space-6)',
  border: '1px solid var(--vn-border-default)',
  borderRadius: 'var(--vn-radius-xl)',
  boxShadow: 'var(--vn-shadow-sm)',
};

export const heroIcon: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 64,
  height: 64,
  borderRadius: 'var(--vn-radius-full)',
};

export const heroEyebrow: CSSProperties = {
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontSize: 'var(--vn-font-size-xs)',
  fontWeight: 'var(--vn-font-weight-semibold)',
  color: 'var(--vn-primary-text)',
  margin: 0,
};

export const heroTitle: CSSProperties = {
  fontSize: 'var(--vn-font-size-3xl)',
  fontWeight: 'var(--vn-font-weight-semibold)',
  letterSpacing: '-0.01em',
  margin: 0,
};

export const heroLede: CSSProperties = {
  color: 'var(--vn-fg-muted)',
  fontSize: 'var(--vn-font-size-lg)',
  maxWidth: 480,
  margin: 0,
  lineHeight: 'var(--vn-line-height-normal)',
};

/** Vertical timeline of "what you can do" steps. */
export const stepList: CSSProperties = {
  display: 'grid',
  gap: 'var(--vn-space-3)',
  width: '100%',
  maxWidth: 520,
  textAlign: 'left',
};

export const stepRow: CSSProperties = {
  display: 'flex',
  gap: 'var(--vn-space-3)',
  alignItems: 'flex-start',
  padding: 'var(--vn-space-4)',
  border: '1px solid var(--vn-border-default)',
  borderRadius: 'var(--vn-radius-lg)',
  background: 'var(--vn-bg-surface)',
};

const marker: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 36,
  height: 36,
  borderRadius: 'var(--vn-radius-full)',
  fontSize: 'var(--vn-font-size-sm)',
  fontWeight: 'var(--vn-font-weight-semibold)',
};

export const markerAccent: CSSProperties = {
  ...marker,
  background: 'var(--vn-primary-subtle)',
  color: 'var(--vn-primary-text)',
  border: '1px solid var(--vn-primary-border)',
};

export const stepTitle: CSSProperties = {
  fontWeight: 'var(--vn-font-weight-semibold)',
  margin: 0,
};

export const stepDesc: CSSProperties = {
  color: 'var(--vn-fg-muted)',
  fontSize: 'var(--vn-font-size-sm)',
  margin: 0,
  lineHeight: 'var(--vn-line-height-normal)',
};
